import {StrictMode} from 'react'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {ReactQueryDevtools} from '@tanstack/react-query-devtools'
import {loadStripe} from '@stripe/stripe-js';
import {BrowserRouter} from "react-router-dom";
import {CssBaseline, ThemeProvider} from '@mui/material'
import {createRoot} from 'react-dom/client'
import theme from './theme'
import {AuthProvider} from "./contexts/AuthContext.tsx";
import {ProductProvider} from "./contexts/ProductContext.tsx";
import App from './App.tsx'
import './i18n';
import {CartProvider} from "./contexts/CartContext.tsx";
import {Elements} from "@stripe/react-stripe-js";
import {OrderProvider} from "./contexts/OrderContext.tsx";
import {PaymentProvider} from "./contexts/PaymentContext.tsx";
import {ReviewProvider} from "./contexts/ReviewContext.tsx";
import {PayPalScriptProvider} from "@paypal/react-paypal-js";
import {SaleProvider} from "./contexts/SaleContext.tsx";
import {DiscountCodeProvider} from "./contexts/DiscountCodeContext.tsx";

const queryClient = new QueryClient()
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);
const payPalClientId = import.meta.env.VITE_PAYPAL_CLIENT_ID

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools initialIsOpen={false}/>
            <BrowserRouter>
                <AuthProvider>
                    <SaleProvider>
                        <DiscountCodeProvider>
                            <ProductProvider>
                                <CartProvider>
                                    <PaymentProvider>
                                        <OrderProvider>
                                            <ReviewProvider>
                                                <ThemeProvider theme={theme}>
                                                    <CssBaseline/>
                                                    <PayPalScriptProvider
                                                        options={{clientId: payPalClientId, currency: 'EUR'}}>
                                                        <Elements stripe={stripePromise}>
                                                            <App/>
                                                        </Elements>
                                                    </PayPalScriptProvider>
                                                </ThemeProvider>
                                            </ReviewProvider>
                                        </OrderProvider>
                                    </PaymentProvider>
                                </CartProvider>
                            </ProductProvider>
                        </DiscountCodeProvider>
                    </SaleProvider>
                </AuthProvider>
            </BrowserRouter>
        </QueryClientProvider>
    </StrictMode>
);
